(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/home/home.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2025 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<section class="home row">',
'',
'  <div class="col-md-4">',
'    <div class="alerts">',
'      <div class="alert alert-info">',
'        <i class="glyphicon glyphicon-user pull-right"></i>',
'        <i class="glyphicon glyphicon-user pull-right"></i>',
'        <a ng-link="users({id: \'all\'})" translate>home.users</a>',
'      </div>',
'      <div class="alert alert-danger" ng-if="home.pendingCount > 0">',
'        <a ng-link="users({id: \'pending\'})">',
'          <span><ng-pluralize count="home.pendingCount"',
'                        when="{\'1\': \'{} {{ &quot;home.waiting_user&quot; | translate }}\',',
'                               \'other\': \'{} {{ &quot;home.waiting_users&quot; | translate }}\'}">',
'          </span><br>',
'          <span class="manage" translate>home.view_manage</span>',
'        </a>',
'      </div>',
'      <div class="alert alert-warning" ng-if="home.expired && home.expired.users.length > 0">',
'        <a ng-link="users({id: home.expired.cn})">',
'          <span><ng-pluralize count="home.expired.users.length"',
'                        when="{\'1\': \'{} {{ &quot;home.expired_user&quot; | translate }}\',',
'                               \'other\': \'{} {{ &quot;home.expired_users&quot; | translate }}\'}">',
'          </span><br>',
'          <span class="manage" translate>home.view_manage</span>',
'        </a>',
'      </div>',
'    </div>',
'',
'    <div class="jumbotron" ng-if="platformInfos.analyticsEnabled">',
'      <h1 ng-if="home.connected && home.connected.results.length > 0" ng-cloack>{{::home.connected.results.length}}</h1>',
'      <p><ng-pluralize count="home.connected.results.length"',
'                       when="{\'0\': \'{{ &quot;home.connected_users_none&quot; | translate }}\',',
'                              \'1\': \'{{ &quot;home.connected_user&quot; | translate }}\',',
'                              \'other\': \'{{ &quot;home.connected_users&quot; | translate }}\'}">',
'      </p>',
'      <div ng-if="home.connected.results && home.connected.results.length > 0">      ',
'        <table class="table table-condensed">',
'          <thead>',
'            <tr>',
'              <th translate>home.nb_requests</th>',
'              <th translate>home.user</th>',
'              <th translate>home.org</th>',
'            </tr>',
'          </thead>',
'          <tbody>',
'            <tr dir-paginate="user in home.connected.results | itemsPerPage: 10">',
'              <td title="{{::user.nb_requests}}">{{::user.nb_requests}}</td>',
'              <td title="{{::user.user}}"><a ng-link="user({id: user.user, tab: \'infos\'})">{{::user.user}}</a></td>',
'              <td title="{{::user.organization}}">{{::user.organization}}</td>',
'            </tr>',
'          </tbody>',
'        </table>',
'        <dir-pagination-controls></dir-pagination-controls>',
'      </div>',
'    </div>',
'',
'  </div>',
'',
'  <div class="col-md-8">',
'    <stats data="home.requests" type="\'line\'" config="[\'date\', \'count\']" title="\'analytics.requests\'" ng-if="platformInfos.analyticsEnabled"></stats>',
'    <logger filter="false" title="true"></logger>',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();